import { html } from "lit";

export default html`<uxt-icon icon="search"></uxt-icon>`;